import strings from "../../config/localization";

export const routes = [
  {
    path: "/bandobast",
    name: strings.bandobast,
    layout: "bandobast",
    permission: "read-bandobast",
  },
  {
    path: "/designations",
    name: strings.designations,
    layout: "designations",
    permission: "read-designation",
  },
  {
    path: "/orgs",
    name: strings.organizations,
    layout: "organizations",
    permission: "read-org",
  },
  {
    path: "/personnel",
    name: strings.personnel,
    layout: "personnel",
    permission: "read-personnel",
  },
  {
    path: "/resourceTypes",
    name: strings.resourceTypes,
    layout: "resourceTypes",
    permission: "read-resource-type",
  },
  {
    path: "/resources",
    name: strings.resources,
    layout: "resources",
    permission: "read-resource",
  },
  {
    path: "/roles",
    name: strings.roles,
    layout: "roles",
    permission: "read-role",
  },
  {
    path: "/users",
    name: strings.users,
    layout: "users",
    permission: "read-user",
  },
  {
    path: "/audit",
    name: strings.audit,
    layout: "audit",
    permission: "global_audit_read",
  },
  {
    path: "/changePwd",
    name: strings.changePwd,
    layout: "changePwd",
  },
];
